import { filter } from 'lodash'

import {
    getBaseSlugFromPath,
    stripHtml
} from 'utils'

import {
    getAccountProjectsUtil
} from 'state/selectors'

import moment from 'moment'

export const getColour = (id, type = 'status') => {
    let colourString = ''

    if (type == 'red') {
        colourString = '#ff4600'
    } else if (type == 'status') {
        switch (id) {
            case 1:
                colourString = '#ffa200'
                break
            case 2:
                colourString = '#049ef7'
                break
            case 3:
                colourString = '#66ff00'
                break
            case 4:
                colourString = '#ff4600'
                break
            case 5:
                colourString = '#ffdf14'
                break
            case 6:
                colourString = '#633490'
                break
            case 7:
                colourString = '#f4436f'
                break
            case 8:
                colourString = '#088446'
                break
        }
    }

    return colourString
}

export const stringIsEmpty = string => {
    if (!string) {
        return true
    }

    return stripHtml(string).trim().length === 0
};

export const parsedEmailAddresses = emails => {
    const allAddresses = typeof emails === 'string' ? emails.replace(new RegExp('\n', 'g'), ',').split(',').filter(email => {
        return email ? email : null;
    }) : emails

    if (!allAddresses.length) {
        return {
            allValid: false,
            invalidAddresses: []
        }
    }

    let invalidAddresses = []

    allAddresses.forEach((email) => {
        if (!emailIsValid(email)) {
            invalidAddresses.push(email)
        }
    })

    if (invalidAddresses.length) {
        return {
            allValid: false,
            invalidAddresses
        }
    }

    return {
        allValid: true,
        validAddresses: allAddresses
    }
}

export const emailIsValid = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase())
}

export const getNotificationUrl = (entities, notification, currentAccount) => {
    let newURL = null

    const key = notification.notifyable_type.replace('App\\', '').toLowerCase() + 's'

    const notifyable = entities[key] ? entities[key][notification.notifyable_id] : notification.notifyable || null

    // NB: currentAccount is not always the one we want for the URL.
    let notificationAccount = entities.accounts[notification.account_id]

    if (!notificationAccount) {
        notificationAccount = currentAccount
    }

    const projectSlug = (() => {
        if(notifyable){
            let project = null

            if(notifyable.project_id){
                project = entities.projects[notifyable.project_id]
            }else if(key === 'comments'){
                const task = entities.tasks[notifyable.task_id]

                if(task){
                    project = entities.projects[task.project_id]
                }
            }else if(key === 'projects'){
                project = notifyable
            }

            if(project){
                return project.slug
            }
        }

        return ''
    })()

    const baseUrl = `/${notificationAccount.slug}/`

    newURL = baseUrl + `projects/` + (projectSlug ? `${projectSlug}/` : '')

    switch (notification.notifyable_type) {
        case 'App\\Comment':
            let task;
            if (!entities.tasks || !entities.tasks[notifyable.task_id]) {
                task = notification.notifyableParent;
            } else {
                task = entities.tasks[notifyable.task_id];
            }

            newURL += 'tasks/' + task.id + '?comment=' + notifyable.id
            break
        case 'App\\Task':
            newURL += 'tasks/' + notifyable.id
            break
        case 'App\\Project':
            newURL += 'tasks'
            break
        case 'App\\Note':
            newURL += 'notes'
            break
        case 'App\\File':
            newURL += 'files'
            break
        case 'App\\Team':
            newURL = baseUrl + 'team'
            break
        case 'App\\Bulletin':
            newURL = baseUrl + 'dashboard'
            break
        case 'App\\Event':
            newURL = baseUrl + 'dashboard?event=' + notification.notifyable_id
            break
        case 'App\\Milestone':
            newURL += 'tasks?milestone=' + notification.notifyable_id
            break
        case 'App\\Message':
            // Chats aren't route-addressable — they live in the dock and are
            // opened via redux (see notifications.jsx handleChatNotificationClick).
            newURL = null
            break
    }

    return newURL

}

export const getThumbUrl = (entity, size = 'thumb') => {
    if (size == 'tiny') {
        if (entity.image_tiny_thumb_url) {
            return entity.image_tiny_thumb_url
        }
    }

    if (size == 'original') {
        if (entity.url) {
            return entity.url
        }

        if (entity.image_url) {
            return entity.image_url
        }
    }

    if (entity.thumb_url) {
        return entity.thumb_url
    } else if (entity.image_thumb_url) {
        return entity.image_thumb_url
    } else if (entity.url) {
        return entity.url
    } else if (entity.image_url) {
        return entity.image_url
    } else {
        return null
    }
}

export const doClickEventListeners = (functionToAttach, isRemoved) => {
    if (!isRemoved) {
        document.addEventListener('mousedown', functionToAttach, false)
        document.addEventListener('touchstart', functionToAttach, false)
    } else {
        document.removeEventListener('mousedown', functionToAttach, false)
        document.removeEventListener('touchstart', functionToAttach, false)
    }
}

export const doSort = (array, type, key, isReverse = false, columnId) => {
    switch (type) {
        case 'alpha':
            array.sort((a, b) => {
                let aText = a[key] ? a[key].toLowerCase() : 'zzz'
                let bText = b[key] ? b[key].toLowerCase() : 'zzz'

                if (isReverse) {
                    aText = b[key] ? b[key].toLowerCase() : 'zzz'
                    bText = a[key] ? a[key].toLowerCase() : 'zzz'
                }

                if (aText < bText.toLowerCase()) return -1
                if (aText > bText.toLowerCase()) return 1
                return 0
            })
            break
        case 'date':
            array.sort((a, b) => {
                let aDate = a[key] ? a[key] : ''
                let bDate = b[key] ? b[key] : ''

                const typeKey = (key && key === 'start') ? 'start' : 'end'

                if (a.column_data && a.column_data[columnId] && a.column_data[columnId][typeKey]) {
                    aDate = a.column_data[columnId][typeKey]
                }

                if (b.column_data && b.column_data[columnId] && b.column_data[columnId][typeKey]) {
                    bDate = b.column_data[columnId][typeKey]
                }

                if (!isReverse) {
                    return (aDate < bDate ? -1 : (aDate > bDate ? 1 : 0))
                } else {
                    return (bDate < aDate ? -1 : (bDate > aDate ? 1 : 0))
                }
            })
            break
        case 'number':
            array.sort((a, b) => {
                let aKey = a[key]
                let bKey = b[key]

                if (a.column_data && a.column_data[columnId]) {
                    aKey = a.column_data[columnId]
                }

                if (b.column_data && b.column_data[columnId]) {
                    bKey = b.column_data[columnId]
                }

                if (!isReverse) {
                    return aKey - bKey
                } else {
                    return bKey - aKey
                }
            })
            break
    }

    return array
}

export const modelTypeToString = modelType => {
    return modelType.replace('App\\', '').toLowerCase()
}

export const removeSoftDeleted = collection => {
    return filter(collection, item => {
        return !item.deleted_at
    })

}

export const getUrl = (props, type, project, task = null) => {
    let accountUrl = getBaseSlugFromPath(props.location.pathname)

    accountUrl += '/projects/'
    accountUrl += project.slug

    if (type == 'task') {
        accountUrl += '/tasks/' + task.id
    }

    return accountUrl
}

export const openItem = (props, type, project, task = null) => {
    props.history.push(getUrl(props, type, project, task))
}

export const getMobileOperatingSystem = _ => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone"
    }

    if (/android/i.test(userAgent)) {
        return "Android"
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS"
    }

    return "unknown"
}

export const isStandardAndNotEarlyAdopter = account => {
    if (!account) {
        return true
    }

    return (!account.isPremium && moment(account.created_at).isAfter(moment('2019-07-06')))
}

export const getTotalAvailableStorage = account => {
    let totalGb = 0

    let packageId = account.isPremium ? 2 : account.package_id

    switch (packageId) {
        case 1:
            if (isStandardAndNotEarlyAdopter(account)) {
                totalGb = 5
            } else {
                totalGb = 30
            }
            break
        case 2:
            totalGb = 1000
            break
        case 3:
            totalGb = 1000
            break
    }

    return totalGb
}

export const doDeepLink = props => {
    if (window.IonicDeeplink) {
        window.IonicDeeplink.route({
            '/nothing/in/particular': {
                target: 'product',
                parent: 'products'
            }
        }, match => {
            console.log('match, somehow?')
        }, nomatch => {
            const openedUrl = nomatch.$link.url.replace('https://app.hassl.co', '')

            // hashRouter will automatically do the hash thing.
            props.history.push(openedUrl)
        })
    }
}

export const getPriceAndSymbol = (account, isAnnual, planAndCurrencyData) => {
    const value = isAnnual ? 60 : 6

    let symbol = '$'

    if (account && account.currency) {
        symbol = account.currency
    } else if (planAndCurrencyData) {
        symbol = planAndCurrencyData.symbol
    }

    return {
        symbol,
        price: value
    }
}

export const getTotalAccountCharge = (account, planAndCurrencyData, discountPercent, billing_is_annual) => {
    if (account && planAndCurrencyData) {
        let actualDiscountPercent = discountPercent ? discountPercent : account.coupon_percent_off

        let totalUsers = 0

        account.users && account.users.forEach(userId => {
            // ignore guests, obvi
            if (!account.guestIds || account.guestIds.indexOf(userId) == -1) {
                totalUsers++
            }
        })

        const {
            symbol,
        } = planAndCurrencyData

        let totalPrice = (billing_is_annual ? 60 : 6) * totalUsers

        if (actualDiscountPercent) {
            totalPrice *= ((100 - actualDiscountPercent) / 100)
        }

        totalPrice = Math.round(totalPrice * 10) / 10

        return (account.currency || symbol) + totalPrice.toFixed(2)
    } else {
        return '$0.00'
    }
}

export const getNextChargeMoment = account => {
    const trialEndDate = getTrialEndDate(account, true)

    if (account.isPremium && trialEndDate) {
        const dayOfCharge = moment(trialEndDate).format('D')
        const dayInThisMonth = moment().startOf('month').add(dayOfCharge - 1, 'days')
        const today = moment().startOf('day')

        if (!dayInThisMonth.isAfter(today)) {
            // it's next month
            dayInThisMonth.add(1, 'month')
        }

        return dayInThisMonth
    }

    return null
}

export const getTrialEndDate = (account, allowAnchorDate = false) => {
    let trialEndDate = null

    if (account.subscriptions && account.subscriptions.length) {
        trialEndDate = account.subscriptions[0].trial_ends_at

        if (!trialEndDate && allowAnchorDate) {
            trialEndDate = account.subscriptions[0].created_at
        }
    } else if (account.trial_ends_at) {
        trialEndDate = account.trial_ends_at
    }

    return trialEndDate
}

export const isBlockedPremiumAccount = account => {
    return account && !account.isPremium && account.package_id > 1 && !account.has_lifetime
}

export const showWhatChanged = (props, prevProps, component) => {
    const name = component.constructor.displayName || component.constructor.name || 'Component'

    console.group(name)

    Object.keys(prevProps).forEach(key => {
        if (prevProps[key] !== props[key]) {
            console.log(`property ${key} changed from ${prevProps[key]} to ${props[key]}`)
        }
    })

    console.groupEnd(name)
}

export const getChangedKeys = (props, nextProps) => {
    const changedKeys = []

    Object.keys(props).forEach(key => {
        if (props[key] !== nextProps[key]) {
            changedKeys.push(key)
        }
    })

    return changedKeys
}

export const hasReachedProjectQuota = (account, allProjects = []) => {
    if (!account || !allProjects) {
        return true
    }

    if (!isStandardAndNotEarlyAdopter(account)) {
        return false
    } else {
        let validProjectCounter = 0

        const projects = getAccountProjectsUtil(account, allProjects)

        projects.forEach(project => {
            if (project && !project.deleted_at) {
                validProjectCounter++
            }
        })

        return validProjectCounter >= 10
    }
}

// remove duplicate empty notes
export const getAvailableNotes = (project, allNotes, roles) => {
    const notes = []

    let hasEmptyNoteAlready = false

    project && project.notes.forEach(noteId => {
        const noteObject = allNotes[noteId]

        if (!noteObject || noteObject.deleted_at) {
            return
        }

        if (!noteObject.visible_to_guests && roles.guest) {
            return
        }

        const noteText = noteObject.text ? noteObject.text.toLowerCase() : ''

        if (!noteText || noteText == '<p></p>') {
            if (hasEmptyNoteAlready) {
                return
            } else {
                hasEmptyNoteAlready = true
            }
        }

        notes.push(noteObject)
    })

    notes.sort((a, b) => {
        return b.updated_at.localeCompare(a.updated_at)
    })

    return notes
}

export const isProjectFavourited = (project, user) => {
    let favouriteProjectsArray = []

    if (user.favourite_projects && !user.favourite_projects.indexOf) {
        favouriteProjectsArray = Object.keys(user.favourite_projects).map(index => {
            const projectId = user.favourite_projects[index]

            return projectId
        })
    } else if (user.favourite_projects) {
        favouriteProjectsArray = user.favourite_projects
    }

    return ~favouriteProjectsArray.indexOf(project.id)
}

export const preloadImages = _ => {
    const paths = [
        '/images/decoration/onboard-toaster-fg.png',
        '/images/decoration/onboard-toaster-bg.jpg'
    ]

    paths.forEach(path => {
        const image = new Image()
        image.src = document.base + path
    })
}

export const toggleMobileControls = isVisible => {
    const footerButtonsElement = document.getElementById('mobile-footer-buttons')
    const headerElement = document.getElementById('account-header')

    const elementsToToggle = [footerButtonsElement, headerElement]

    elementsToToggle.forEach(element => {
        if (element) {
            if (isVisible) {
                element.classList.remove('scrolled')
            } else {
                element.classList.add('scrolled')
            }
        }
    })
}

export const isLoadingOtherAccount = account => {
    return account.optimistic || !window.location.href.includes('/' + account.slug + '/')
}

export const getAllCountries = _ => {
    return [
        { name: 'Afghanistan', id: 'AF' },
        { name: 'Åland Islands', id: 'AX' },
        { name: 'Albania', id: 'AL' },
        { name: 'Algeria', id: 'DZ' },
        { name: 'American Samoa', id: 'AS' },
        { name: 'AndorrA', id: 'AD' },
        { name: 'Angola', id: 'AO' },
        { name: 'Anguilla', id: 'AI' },
        { name: 'Antarctica', id: 'AQ' },
        { name: 'Antigua and Barbuda', id: 'AG' },
        { name: 'Argentina', id: 'AR' },
        { name: 'Armenia', id: 'AM' },
        { name: 'Aruba', id: 'AW' },
        { name: 'Australia', id: 'AU' },
        { name: 'Austria', id: 'AT' },
        { name: 'Azerbaijan', id: 'AZ' },
        { name: 'Bahamas', id: 'BS' },
        { name: 'Bahrain', id: 'BH' },
        { name: 'Bangladesh', id: 'BD' },
        { name: 'Barbados', id: 'BB' },
        { name: 'Belarus', id: 'BY' },
        { name: 'Belgium', id: 'BE' },
        { name: 'Belize', id: 'BZ' },
        { name: 'Benin', id: 'BJ' },
        { name: 'Bermuda', id: 'BM' },
        { name: 'Bhutan', id: 'BT' },
        { name: 'Bolivia', id: 'BO' },
        { name: 'Bosnia and Herzegovina', id: 'BA' },
        { name: 'Botswana', id: 'BW' },
        { name: 'Bouvet Island', id: 'BV' },
        { name: 'Brazil', id: 'BR' },
        { name: 'British Indian Ocean Territory', id: 'IO' },
        { name: 'Brunei Darussalam', id: 'BN' },
        { name: 'Bulgaria', id: 'BG' },
        { name: 'Burkina Faso', id: 'BF' },
        { name: 'Burundi', id: 'BI' },
        { name: 'Cambodia', id: 'KH' },
        { name: 'Cameroon', id: 'CM' },
        { name: 'Canada', id: 'CA' },
        { name: 'Cape Verde', id: 'CV' },
        { name: 'Cayman Islands', id: 'KY' },
        { name: 'Central African Republic', id: 'CF' },
        { name: 'Chad', id: 'TD' },
        { name: 'Chile', id: 'CL' },
        { name: 'China', id: 'CN' },
        { name: 'Christmas Island', id: 'CX' },
        { name: 'Cocos (Keeling) Islands', id: 'CC' },
        { name: 'Colombia', id: 'CO' },
        { name: 'Comoros', id: 'KM' },
        { name: 'Congo', id: 'CG' },
        { name: 'Congo, The Democratic Republic of the', id: 'CD' },
        { name: 'Cook Islands', id: 'CK' },
        { name: 'Costa Rica', id: 'CR' },
        { name: 'Cote D\'Ivoire', id: 'CI' },
        { name: 'Croatia', id: 'HR' },
        { name: 'Cuba', id: 'CU' },
        { name: 'Cyprus', id: 'CY' },
        { name: 'Czech Republic', id: 'CZ' },
        { name: 'Denmark', id: 'DK' },
        { name: 'Djibouti', id: 'DJ' },
        { name: 'Dominica', id: 'DM' },
        { name: 'Dominican Republic', id: 'DO' },
        { name: 'Ecuador', id: 'EC' },
        { name: 'Egypt', id: 'EG' },
        { name: 'El Salvador', id: 'SV' },
        { name: 'Equatorial Guinea', id: 'GQ' },
        { name: 'Eritrea', id: 'ER' },
        { name: 'Estonia', id: 'EE' },
        { name: 'Ethiopia', id: 'ET' },
        { name: 'Falkland Islands (Malvinas)', id: 'FK' },
        { name: 'Faroe Islands', id: 'FO' },
        { name: 'Fiji', id: 'FJ' },
        { name: 'Finland', id: 'FI' },
        { name: 'France', id: 'FR' },
        { name: 'French Guiana', id: 'GF' },
        { name: 'French Polynesia', id: 'PF' },
        { name: 'French Southern Territories', id: 'TF' },
        { name: 'Gabon', id: 'GA' },
        { name: 'Gambia', id: 'GM' },
        { name: 'Georgia', id: 'GE' },
        { name: 'Germany', id: 'DE' },
        { name: 'Ghana', id: 'GH' },
        { name: 'Gibraltar', id: 'GI' },
        { name: 'Greece', id: 'GR' },
        { name: 'Greenland', id: 'GL' },
        { name: 'Grenada', id: 'GD' },
        { name: 'Guadeloupe', id: 'GP' },
        { name: 'Guam', id: 'GU' },
        { name: 'Guatemala', id: 'GT' },
        { name: 'Guernsey', id: 'GG' },
        { name: 'Guinea', id: 'GN' },
        { name: 'Guinea-Bissau', id: 'GW' },
        { name: 'Guyana', id: 'GY' },
        { name: 'Haiti', id: 'HT' },
        { name: 'Heard Island and Mcdonald Islands', id: 'HM' },
        { name: 'Holy See (Vatican City State)', id: 'VA' },
        { name: 'Honduras', id: 'HN' },
        { name: 'Hong Kong', id: 'HK' },
        { name: 'Hungary', id: 'HU' },
        { name: 'Iceland', id: 'IS' },
        { name: 'India', id: 'IN' },
        { name: 'Indonesia', id: 'ID' },
        { name: 'Iran, Islamic Republic Of', id: 'IR' },
        { name: 'Iraq', id: 'IQ' },
        { name: 'Ireland', id: 'IE' },
        { name: 'Isle of Man', id: 'IM' },
        { name: 'Israel', id: 'IL' },
        { name: 'Italy', id: 'IT' },
        { name: 'Jamaica', id: 'JM' },
        { name: 'Japan', id: 'JP' },
        { name: 'Jersey', id: 'JE' },
        { name: 'Jordan', id: 'JO' },
        { name: 'Kazakhstan', id: 'KZ' },
        { name: 'Kenya', id: 'KE' },
        { name: 'Kiribati', id: 'KI' },
        { name: 'Korea, Democratic People\'S Republic of', id: 'KP' },
        { name: 'Korea, Republic of', id: 'KR' },
        { name: 'Kuwait', id: 'KW' },
        { name: 'Kyrgyzstan', id: 'KG' },
        { name: 'Lao People\'S Democratic Republic', id: 'LA' },
        { name: 'Latvia', id: 'LV' },
        { name: 'Lebanon', id: 'LB' },
        { name: 'Lesotho', id: 'LS' },
        { name: 'Liberia', id: 'LR' },
        { name: 'Libyan Arab Jamahiriya', id: 'LY' },
        { name: 'Liechtenstein', id: 'LI' },
        { name: 'Lithuania', id: 'LT' },
        { name: 'Luxembourg', id: 'LU' },
        { name: 'Macao', id: 'MO' },
        { name: 'Macedonia, The Former Yugoslav Republic of', id: 'MK' },
        { name: 'Madagascar', id: 'MG' },
        { name: 'Malawi', id: 'MW' },
        { name: 'Malaysia', id: 'MY' },
        { name: 'Maldives', id: 'MV' },
        { name: 'Mali', id: 'ML' },
        { name: 'Malta', id: 'MT' },
        { name: 'Marshall Islands', id: 'MH' },
        { name: 'Martinique', id: 'MQ' },
        { name: 'Mauritania', id: 'MR' },
        { name: 'Mauritius', id: 'MU' },
        { name: 'Mayotte', id: 'YT' },
        { name: 'Mexico', id: 'MX' },
        { name: 'Micronesia, Federated States of', id: 'FM' },
        { name: 'Moldova, Republic of', id: 'MD' },
        { name: 'Monaco', id: 'MC' },
        { name: 'Mongolia', id: 'MN' },
        { name: 'Montserrat', id: 'MS' },
        { name: 'Morocco', id: 'MA' },
        { name: 'Mozambique', id: 'MZ' },
        { name: 'Myanmar', id: 'MM' },
        { name: 'Namibia', id: 'NA' },
        { name: 'Nauru', id: 'NR' },
        { name: 'Nepal', id: 'NP' },
        { name: 'Netherlands', id: 'NL' },
        { name: 'Netherlands Antilles', id: 'AN' },
        { name: 'New Caledonia', id: 'NC' },
        { name: 'New Zealand', id: 'NZ' },
        { name: 'Nicaragua', id: 'NI' },
        { name: 'Niger', id: 'NE' },
        { name: 'Nigeria', id: 'NG' },
        { name: 'Niue', id: 'NU' },
        { name: 'Norfolk Island', id: 'NF' },
        { name: 'Northern Mariana Islands', id: 'MP' },
        { name: 'Norway', id: 'NO' },
        { name: 'Oman', id: 'OM' },
        { name: 'Pakistan', id: 'PK' },
        { name: 'Palau', id: 'PW' },
        { name: 'Palestinian Territory, Occupied', id: 'PS' },
        { name: 'Panama', id: 'PA' },
        { name: 'Papua New Guinea', id: 'PG' },
        { name: 'Paraguay', id: 'PY' },
        { name: 'Peru', id: 'PE' },
        { name: 'Philippines', id: 'PH' },
        { name: 'Pitcairn', id: 'PN' },
        { name: 'Poland', id: 'PL' },
        { name: 'Portugal', id: 'PT' },
        { name: 'Puerto Rico', id: 'PR' },
        { name: 'Qatar', id: 'QA' },
        { name: 'Reunion', id: 'RE' },
        { name: 'Romania', id: 'RO' },
        { name: 'Russian Federation', id: 'RU' },
        { name: 'RWANDA', id: 'RW' },
        { name: 'Saint Helena', id: 'SH' },
        { name: 'Saint Kitts and Nevis', id: 'KN' },
        { name: 'Saint Lucia', id: 'LC' },
        { name: 'Saint Pierre and Miquelon', id: 'PM' },
        { name: 'Saint Vincent and the Grenadines', id: 'VC' },
        { name: 'Samoa', id: 'WS' },
        { name: 'San Marino', id: 'SM' },
        { name: 'Sao Tome and Principe', id: 'ST' },
        { name: 'Saudi Arabia', id: 'SA' },
        { name: 'Senegal', id: 'SN' },
        { name: 'Serbia and Montenegro', id: 'CS' },
        { name: 'Seychelles', id: 'SC' },
        { name: 'Sierra Leone', id: 'SL' },
        { name: 'Singapore', id: 'SG' },
        { name: 'Slovakia', id: 'SK' },
        { name: 'Slovenia', id: 'SI' },
        { name: 'Solomon Islands', id: 'SB' },
        { name: 'Somalia', id: 'SO' },
        { name: 'South Africa', id: 'ZA' },
        { name: 'South Georgia and the South Sandwich Islands', id: 'GS' },
        { name: 'Spain', id: 'ES' },
        { name: 'Sri Lanka', id: 'LK' },
        { name: 'Sudan', id: 'SD' },
        { name: 'Suriname', id: 'SR' },
        { name: 'Svalbard and Jan Mayen', id: 'SJ' },
        { name: 'Swaziland', id: 'SZ' },
        { name: 'Sweden', id: 'SE' },
        { name: 'Switzerland', id: 'CH' },
        { name: 'Syrian Arab Republic', id: 'SY' },
        { name: 'Taiwan, Province of China', id: 'TW' },
        { name: 'Tajikistan', id: 'TJ' },
        { name: 'Tanzania, United Republic of', id: 'TZ' },
        { name: 'Thailand', id: 'TH' },
        { name: 'Timor-Leste', id: 'TL' },
        { name: 'Togo', id: 'TG' },
        { name: 'Tokelau', id: 'TK' },
        { name: 'Tonga', id: 'TO' },
        { name: 'Trinidad and Tobago', id: 'TT' },
        { name: 'Tunisia', id: 'TN' },
        { name: 'Turkey', id: 'TR' },
        { name: 'Turkmenistan', id: 'TM' },
        { name: 'Turks and Caicos Islands', id: 'TC' },
        { name: 'Tuvalu', id: 'TV' },
        { name: 'Uganda', id: 'UG' },
        { name: 'Ukraine', id: 'UA' },
        { name: 'United Arab Emirates', id: 'AE' },
        { name: 'United Kingdom', id: 'GB' },
        { name: 'United States', id: 'US' },
        { name: 'United States Minor Outlying Islands', id: 'UM' },
        { name: 'Uruguay', id: 'UY' },
        { name: 'Uzbekistan', id: 'UZ' },
        { name: 'Vanuatu', id: 'VU' },
        { name: 'Venezuela', id: 'VE' },
        { name: 'Viet Nam', id: 'VN' },
        { name: 'Virgin Islands, British', id: 'VG' },
        { name: 'Virgin Islands, U.S.', id: 'VI' },
        { name: 'Wallis and Futuna', id: 'WF' },
        { name: 'Western Sahara', id: 'EH' },
        { name: 'Yemen', id: 'YE' },
        { name: 'Zambia', id: 'ZM' },
        { name: 'Zimbabwe', id: 'ZW' }
    ]
}

export const getCountryCodeFromCountryName = country => {
    const codes = [{ "name": "Afghanistan", "alpha-3": "AFG", "country-code": "004" }, { "name": "Åland Islands", "alpha-3": "ALA", "country-code": "248" }, { "name": "Albania", "alpha-3": "ALB", "country-code": "008" }, { "name": "Algeria", "alpha-3": "DZA", "country-code": "012" }, { "name": "American Samoa", "alpha-3": "ASM", "country-code": "016" }, { "name": "Andorra", "alpha-3": "AND", "country-code": "020" }, { "name": "Angola", "alpha-3": "AGO", "country-code": "024" }, { "name": "Anguilla", "alpha-3": "AIA", "country-code": "660" }, { "name": "Antarctica", "alpha-3": "ATA", "country-code": "010" }, { "name": "Antigua and Barbuda", "alpha-3": "ATG", "country-code": "028" }, { "name": "Argentina", "alpha-3": "ARG", "country-code": "032" }, { "name": "Armenia", "alpha-3": "ARM", "country-code": "051" }, { "name": "Aruba", "alpha-3": "ABW", "country-code": "533" }, { "name": "Australia", "alpha-3": "AUS", "country-code": "036" }, { "name": "Austria", "alpha-3": "AUT", "country-code": "040" }, { "name": "Azerbaijan", "alpha-3": "AZE", "country-code": "031" }, { "name": "Bahamas", "alpha-3": "BHS", "country-code": "044" }, { "name": "Bahrain", "alpha-3": "BHR", "country-code": "048" }, { "name": "Bangladesh", "alpha-3": "BGD", "country-code": "050" }, { "name": "Barbados", "alpha-3": "BRB", "country-code": "052" }, { "name": "Belarus", "alpha-3": "BLR", "country-code": "112" }, { "name": "Belgium", "alpha-3": "BEL", "country-code": "056" }, { "name": "Belize", "alpha-3": "BLZ", "country-code": "084" }, { "name": "Benin", "alpha-3": "BEN", "country-code": "204" }, { "name": "Bermuda", "alpha-3": "BMU", "country-code": "060" }, { "name": "Bhutan", "alpha-3": "BTN", "country-code": "064" }, { "name": "Bolivia (Plurinational State of)", "alpha-3": "BOL", "country-code": "068" }, { "name": "Bonaire, Sint Eustatius and Saba", "alpha-3": "BES", "country-code": "535" }, { "name": "Bosnia and Herzegovina", "alpha-3": "BIH", "country-code": "070" }, { "name": "Botswana", "alpha-3": "BWA", "country-code": "072" }, { "name": "Bouvet Island", "alpha-3": "BVT", "country-code": "074" }, { "name": "Brazil", "alpha-3": "BRA", "country-code": "076" }, { "name": "British Indian Ocean Territory", "alpha-3": "IOT", "country-code": "086" }, { "name": "Brunei Darussalam", "alpha-3": "BRN", "country-code": "096" }, { "name": "Bulgaria", "alpha-3": "BGR", "country-code": "100" }, { "name": "Burkina Faso", "alpha-3": "BFA", "country-code": "854" }, { "name": "Burundi", "alpha-3": "BDI", "country-code": "108" }, { "name": "Cabo Verde", "alpha-3": "CPV", "country-code": "132" }, { "name": "Cambodia", "alpha-3": "KHM", "country-code": "116" }, { "name": "Cameroon", "alpha-3": "CMR", "country-code": "120" }, { "name": "Canada", "alpha-3": "CAN", "country-code": "124" }, { "name": "Cayman Islands", "alpha-3": "CYM", "country-code": "136" }, { "name": "Central African Republic", "alpha-3": "CAF", "country-code": "140" }, { "name": "Chad", "alpha-3": "TCD", "country-code": "148" }, { "name": "Chile", "alpha-3": "CHL", "country-code": "152" }, { "name": "China", "alpha-3": "CHN", "country-code": "156" }, { "name": "Christmas Island", "alpha-3": "CXR", "country-code": "162" }, { "name": "Cocos (Keeling) Islands", "alpha-3": "CCK", "country-code": "166" }, { "name": "Colombia", "alpha-3": "COL", "country-code": "170" }, { "name": "Comoros", "alpha-3": "COM", "country-code": "174" }, { "name": "Congo", "alpha-3": "COG", "country-code": "178" }, { "name": "Congo, Democratic Republic of the", "alpha-3": "COD", "country-code": "180" }, { "name": "Cook Islands", "alpha-3": "COK", "country-code": "184" }, { "name": "Costa Rica", "alpha-3": "CRI", "country-code": "188" }, { "name": "Côte d'Ivoire", "alpha-3": "CIV", "country-code": "384" }, { "name": "Croatia", "alpha-3": "HRV", "country-code": "191" }, { "name": "Cuba", "alpha-3": "CUB", "country-code": "192" }, { "name": "Curaçao", "alpha-3": "CUW", "country-code": "531" }, { "name": "Cyprus", "alpha-3": "CYP", "country-code": "196" }, { "name": "Czechia", "alpha-3": "CZE", "country-code": "203" }, { "name": "Denmark", "alpha-3": "DNK", "country-code": "208" }, { "name": "Djibouti", "alpha-3": "DJI", "country-code": "262" }, { "name": "Dominica", "alpha-3": "DMA", "country-code": "212" }, { "name": "Dominican Republic", "alpha-3": "DOM", "country-code": "214" }, { "name": "Ecuador", "alpha-3": "ECU", "country-code": "218" }, { "name": "Egypt", "alpha-3": "EGY", "country-code": "818" }, { "name": "El Salvador", "alpha-3": "SLV", "country-code": "222" }, { "name": "Equatorial Guinea", "alpha-3": "GNQ", "country-code": "226" }, { "name": "Eritrea", "alpha-3": "ERI", "country-code": "232" }, { "name": "Estonia", "alpha-3": "EST", "country-code": "233" }, { "name": "Eswatini", "alpha-3": "SWZ", "country-code": "748" }, { "name": "Ethiopia", "alpha-3": "ETH", "country-code": "231" }, { "name": "Falkland Islands (Malvinas)", "alpha-3": "FLK", "country-code": "238" }, { "name": "Faroe Islands", "alpha-3": "FRO", "country-code": "234" }, { "name": "Fiji", "alpha-3": "FJI", "country-code": "242" }, { "name": "Finland", "alpha-3": "FIN", "country-code": "246" }, { "name": "France", "alpha-3": "FRA", "country-code": "250" }, { "name": "French Guiana", "alpha-3": "GUF", "country-code": "254" }, { "name": "French Polynesia", "alpha-3": "PYF", "country-code": "258" }, { "name": "French Southern Territories", "alpha-3": "ATF", "country-code": "260" }, { "name": "Gabon", "alpha-3": "GAB", "country-code": "266" }, { "name": "Gambia", "alpha-3": "GMB", "country-code": "270" }, { "name": "Georgia", "alpha-3": "GEO", "country-code": "268" }, { "name": "Germany", "alpha-3": "DEU", "country-code": "276" }, { "name": "Ghana", "alpha-3": "GHA", "country-code": "288" }, { "name": "Gibraltar", "alpha-3": "GIB", "country-code": "292" }, { "name": "Greece", "alpha-3": "GRC", "country-code": "300" }, { "name": "Greenland", "alpha-3": "GRL", "country-code": "304" }, { "name": "Grenada", "alpha-3": "GRD", "country-code": "308" }, { "name": "Guadeloupe", "alpha-3": "GLP", "country-code": "312" }, { "name": "Guam", "alpha-3": "GUM", "country-code": "316" }, { "name": "Guatemala", "alpha-3": "GTM", "country-code": "320" }, { "name": "Guernsey", "alpha-3": "GGY", "country-code": "831" }, { "name": "Guinea", "alpha-3": "GIN", "country-code": "324" }, { "name": "Guinea-Bissau", "alpha-3": "GNB", "country-code": "624" }, { "name": "Guyana", "alpha-3": "GUY", "country-code": "328" }, { "name": "Haiti", "alpha-3": "HTI", "country-code": "332" }, { "name": "Heard Island and McDonald Islands", "alpha-3": "HMD", "country-code": "334" }, { "name": "Holy See", "alpha-3": "VAT", "country-code": "336" }, { "name": "Honduras", "alpha-3": "HND", "country-code": "340" }, { "name": "Hong Kong", "alpha-3": "HKG", "country-code": "344" }, { "name": "Hungary", "alpha-3": "HUN", "country-code": "348" }, { "name": "Iceland", "alpha-3": "ISL", "country-code": "352" }, { "name": "India", "alpha-3": "IND", "country-code": "356" }, { "name": "Indonesia", "alpha-3": "IDN", "country-code": "360" }, { "name": "Iran (Islamic Republic of)", "alpha-3": "IRN", "country-code": "364" }, { "name": "Iraq", "alpha-3": "IRQ", "country-code": "368" }, { "name": "Ireland", "alpha-3": "IRL", "country-code": "372" }, { "name": "Isle of Man", "alpha-3": "IMN", "country-code": "833" }, { "name": "Israel", "alpha-3": "ISR", "country-code": "376" }, { "name": "Italy", "alpha-3": "ITA", "country-code": "380" }, { "name": "Jamaica", "alpha-3": "JAM", "country-code": "388" }, { "name": "Japan", "alpha-3": "JPN", "country-code": "392" }, { "name": "Jersey", "alpha-3": "JEY", "country-code": "832" }, { "name": "Jordan", "alpha-3": "JOR", "country-code": "400" }, { "name": "Kazakhstan", "alpha-3": "KAZ", "country-code": "398" }, { "name": "Kenya", "alpha-3": "KEN", "country-code": "404" }, { "name": "Kiribati", "alpha-3": "KIR", "country-code": "296" }, { "name": "Korea (Democratic People's Republic of)", "alpha-3": "PRK", "country-code": "408" }, { "name": "Korea, Republic of", "alpha-3": "KOR", "country-code": "410" }, { "name": "Kuwait", "alpha-3": "KWT", "country-code": "414" }, { "name": "Kyrgyzstan", "alpha-3": "KGZ", "country-code": "417" }, { "name": "Lao People's Democratic Republic", "alpha-3": "LAO", "country-code": "418" }, { "name": "Latvia", "alpha-3": "LVA", "country-code": "428" }, { "name": "Lebanon", "alpha-3": "LBN", "country-code": "422" }, { "name": "Lesotho", "alpha-3": "LSO", "country-code": "426" }, { "name": "Liberia", "alpha-3": "LBR", "country-code": "430" }, { "name": "Libya", "alpha-3": "LBY", "country-code": "434" }, { "name": "Liechtenstein", "alpha-3": "LIE", "country-code": "438" }, { "name": "Lithuania", "alpha-3": "LTU", "country-code": "440" }, { "name": "Luxembourg", "alpha-3": "LUX", "country-code": "442" }, { "name": "Macao", "alpha-3": "MAC", "country-code": "446" }, { "name": "Madagascar", "alpha-3": "MDG", "country-code": "450" }, { "name": "Malawi", "alpha-3": "MWI", "country-code": "454" }, { "name": "Malaysia", "alpha-3": "MYS", "country-code": "458" }, { "name": "Maldives", "alpha-3": "MDV", "country-code": "462" }, { "name": "Mali", "alpha-3": "MLI", "country-code": "466" }, { "name": "Malta", "alpha-3": "MLT", "country-code": "470" }, { "name": "Marshall Islands", "alpha-3": "MHL", "country-code": "584" }, { "name": "Martinique", "alpha-3": "MTQ", "country-code": "474" }, { "name": "Mauritania", "alpha-3": "MRT", "country-code": "478" }, { "name": "Mauritius", "alpha-3": "MUS", "country-code": "480" }, { "name": "Mayotte", "alpha-3": "MYT", "country-code": "175" }, { "name": "Mexico", "alpha-3": "MEX", "country-code": "484" }, { "name": "Micronesia (Federated States of)", "alpha-3": "FSM", "country-code": "583" }, { "name": "Moldova, Republic of", "alpha-3": "MDA", "country-code": "498" }, { "name": "Monaco", "alpha-3": "MCO", "country-code": "492" }, { "name": "Mongolia", "alpha-3": "MNG", "country-code": "496" }, { "name": "Montenegro", "alpha-3": "MNE", "country-code": "499" }, { "name": "Montserrat", "alpha-3": "MSR", "country-code": "500" }, { "name": "Morocco", "alpha-3": "MAR", "country-code": "504" }, { "name": "Mozambique", "alpha-3": "MOZ", "country-code": "508" }, { "name": "Myanmar", "alpha-3": "MMR", "country-code": "104" }, { "name": "Namibia", "alpha-3": "NAM", "country-code": "516" }, { "name": "Nauru", "alpha-3": "NRU", "country-code": "520" }, { "name": "Nepal", "alpha-3": "NPL", "country-code": "524" }, { "name": "Netherlands", "alpha-3": "NLD", "country-code": "528" }, { "name": "New Caledonia", "alpha-3": "NCL", "country-code": "540" }, { "name": "New Zealand", "alpha-3": "NZL", "country-code": "554" }, { "name": "Nicaragua", "alpha-3": "NIC", "country-code": "558" }, { "name": "Niger", "alpha-3": "NER", "country-code": "562" }, { "name": "Nigeria", "alpha-3": "NGA", "country-code": "566" }, { "name": "Niue", "alpha-3": "NIU", "country-code": "570" }, { "name": "Norfolk Island", "alpha-3": "NFK", "country-code": "574" }, { "name": "North Macedonia", "alpha-3": "MKD", "country-code": "807" }, { "name": "Northern Mariana Islands", "alpha-3": "MNP", "country-code": "580" }, { "name": "Norway", "alpha-3": "NOR", "country-code": "578" }, { "name": "Oman", "alpha-3": "OMN", "country-code": "512" }, { "name": "Pakistan", "alpha-3": "PAK", "country-code": "586" }, { "name": "Palau", "alpha-3": "PLW", "country-code": "585" }, { "name": "Palestine, State of", "alpha-3": "PSE", "country-code": "275" }, { "name": "Panama", "alpha-3": "PAN", "country-code": "591" }, { "name": "Papua New Guinea", "alpha-3": "PNG", "country-code": "598" }, { "name": "Paraguay", "alpha-3": "PRY", "country-code": "600" }, { "name": "Peru", "alpha-3": "PER", "country-code": "604" }, { "name": "Philippines", "alpha-3": "PHL", "country-code": "608" }, { "name": "Pitcairn", "alpha-3": "PCN", "country-code": "612" }, { "name": "Poland", "alpha-3": "POL", "country-code": "616" }, { "name": "Portugal", "alpha-3": "PRT", "country-code": "620" }, { "name": "Puerto Rico", "alpha-3": "PRI", "country-code": "630" }, { "name": "Qatar", "alpha-3": "QAT", "country-code": "634" }, { "name": "Réunion", "alpha-3": "REU", "country-code": "638" }, { "name": "Romania", "alpha-3": "ROU", "country-code": "642" }, { "name": "Russian Federation", "alpha-3": "RUS", "country-code": "643" }, { "name": "Rwanda", "alpha-3": "RWA", "country-code": "646" }, { "name": "Saint Barthélemy", "alpha-3": "BLM", "country-code": "652" }, { "name": "Saint Helena, Ascension and Tristan da Cunha", "alpha-3": "SHN", "country-code": "654" }, { "name": "Saint Kitts and Nevis", "alpha-3": "KNA", "country-code": "659" }, { "name": "Saint Lucia", "alpha-3": "LCA", "country-code": "662" }, { "name": "Saint Martin (French part)", "alpha-3": "MAF", "country-code": "663" }, { "name": "Saint Pierre and Miquelon", "alpha-3": "SPM", "country-code": "666" }, { "name": "Saint Vincent and the Grenadines", "alpha-3": "VCT", "country-code": "670" }, { "name": "Samoa", "alpha-3": "WSM", "country-code": "882" }, { "name": "San Marino", "alpha-3": "SMR", "country-code": "674" }, { "name": "Sao Tome and Principe", "alpha-3": "STP", "country-code": "678" }, { "name": "Saudi Arabia", "alpha-3": "SAU", "country-code": "682" }, { "name": "Senegal", "alpha-3": "SEN", "country-code": "686" }, { "name": "Serbia", "alpha-3": "SRB", "country-code": "688" }, { "name": "Seychelles", "alpha-3": "SYC", "country-code": "690" }, { "name": "Sierra Leone", "alpha-3": "SLE", "country-code": "694" }, { "name": "Singapore", "alpha-3": "SGP", "country-code": "702" }, { "name": "Sint Maarten (Dutch part)", "alpha-3": "SXM", "country-code": "534" }, { "name": "Slovakia", "alpha-3": "SVK", "country-code": "703" }, { "name": "Slovenia", "alpha-3": "SVN", "country-code": "705" }, { "name": "Solomon Islands", "alpha-3": "SLB", "country-code": "090" }, { "name": "Somalia", "alpha-3": "SOM", "country-code": "706" }, { "name": "South Africa", "alpha-3": "ZAF", "country-code": "710" }, { "name": "South Georgia and the South Sandwich Islands", "alpha-3": "SGS", "country-code": "239" }, { "name": "South Sudan", "alpha-3": "SSD", "country-code": "728" }, { "name": "Spain", "alpha-3": "ESP", "country-code": "724" }, { "name": "Sri Lanka", "alpha-3": "LKA", "country-code": "144" }, { "name": "Sudan", "alpha-3": "SDN", "country-code": "729" }, { "name": "Suriname", "alpha-3": "SUR", "country-code": "740" }, { "name": "Svalbard and Jan Mayen", "alpha-3": "SJM", "country-code": "744" }, { "name": "Sweden", "alpha-3": "SWE", "country-code": "752" }, { "name": "Switzerland", "alpha-3": "CHE", "country-code": "756" }, { "name": "Syrian Arab Republic", "alpha-3": "SYR", "country-code": "760" }, { "name": "Taiwan, Province of China", "alpha-3": "TWN", "country-code": "158" }, { "name": "Tajikistan", "alpha-3": "TJK", "country-code": "762" }, { "name": "Tanzania, United Republic of", "alpha-3": "TZA", "country-code": "834" }, { "name": "Thailand", "alpha-3": "THA", "country-code": "764" }, { "name": "Timor-Leste", "alpha-3": "TLS", "country-code": "626" }, { "name": "Togo", "alpha-3": "TGO", "country-code": "768" }, { "name": "Tokelau", "alpha-3": "TKL", "country-code": "772" }, { "name": "Tonga", "alpha-3": "TON", "country-code": "776" }, { "name": "Trinidad and Tobago", "alpha-3": "TTO", "country-code": "780" }, { "name": "Tunisia", "alpha-3": "TUN", "country-code": "788" }, { "name": "Turkey", "alpha-3": "TUR", "country-code": "792" }, { "name": "Turkmenistan", "alpha-3": "TKM", "country-code": "795" }, { "name": "Turks and Caicos Islands", "alpha-3": "TCA", "country-code": "796" }, { "name": "Tuvalu", "alpha-3": "TUV", "country-code": "798" }, { "name": "Uganda", "alpha-3": "UGA", "country-code": "800" }, { "name": "Ukraine", "alpha-3": "UKR", "country-code": "804" }, { "name": "United Arab Emirates", "alpha-3": "ARE", "country-code": "784" }, { "name": "United Kingdom", "alpha-3": "GBR", "country-code": "826" }, { "name": "United States of America", "alpha-3": "USA", "country-code": "840" }, { "name": "United States Minor Outlying Islands", "alpha-3": "UMI", "country-code": "581" }, { "name": "Uruguay", "alpha-3": "URY", "country-code": "858" }, { "name": "Uzbekistan", "alpha-3": "UZB", "country-code": "860" }, { "name": "Vanuatu", "alpha-3": "VUT", "country-code": "548" }, { "name": "Venezuela (Bolivarian Republic of)", "alpha-3": "VEN", "country-code": "862" }, { "name": "Viet Nam", "alpha-3": "VNM", "country-code": "704" }, { "name": "Virgin Islands (British)", "alpha-3": "VGB", "country-code": "092" }, { "name": "Virgin Islands (U.S.)", "alpha-3": "VIR", "country-code": "850" }, { "name": "Wallis and Futuna", "alpha-3": "WLF", "country-code": "876" }, { "name": "Western Sahara", "alpha-3": "ESH", "country-code": "732" }, { "name": "Yemen", "alpha-3": "YEM", "country-code": "887" }, { "name": "Zambia", "alpha-3": "ZMB", "country-code": "894" }, { "name": "Zimbabwe", "alpha-3": "ZWE", "country-code": "716" }]

    const _country = codes.find(code => {
        return code.name === country
    })

    return _country ? _country['alpha-3'] : ''

}

export const getDateString = () => {
    // Server timestamps come from Laravel running in Australia/Melbourne
    // (UTC+10, or +11 during DST). These strings get compared against server
    // updated_at values to pick merge direction, so a hardcoded +11 puts
    // local stamps an hour in the future for half the year and makes server
    // data lose merges. Let the runtime resolve the offset instead.
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Australia/Melbourne',
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).formatToParts(new Date())

    const get = type => parts.find(part => part.type === type).value

    return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}:${get('second')}`
}

export const getSessionsFromTimeInput = timeInput => {
    let totalSeconds = 0

    const timesArray = timeInput.split(':')

    timesArray.forEach((group, index) => {
        const numberValue = parseInt(group)

        switch (index) {
            case 0:
                totalSeconds += (numberValue * 3600)
                break
            case 1:
                totalSeconds += (numberValue * 60)
                break
            case 2:
                totalSeconds += numberValue
                break
        }
    })

    return totalSeconds
}

export const i18nCopy = text => {
    let _text = text

    _text = _text.replace('isat','izat')

    return _text
}

export const getDashboardOnboardingSteps = (account, user) => {
    const isAccountCreator = (account && user) ? account.created_by === user.id : false

    return isAccountCreator ? [
        {
            key: 'HOP_IN',
            label: 'Hop on in!'
        }, {
            key: 'CREATED_PROJECT',
            label: 'Create a project'
        }, {
            key: 'CREATED_NEW_TASK',
            label: 'Create a task'
        }, {
            key: 'POSTED_COMMENT',
            label: 'Post a comment on a task'
        }, {
            key: 'CUSTOMISED_PROJECT',
            label: 'Customise a project'
        }, {
            key: 'INVITED_USER',
            label: 'Invite your team'
        }
    ] : [
        {
            key: 'HOP_IN',
            label: 'Join your team!'
        },{
            key: 'OPENED_PROJECT',
            label: 'Open a project'
        }, {
            key: 'CREATED_NEW_TASK',
            label: 'Create a task'
        }, {
            key: 'POSTED_COMMENT',
            label: 'Post a comment on a task'
        }, {
            key: 'SEND_CHAT_MESSAGE',
            label: 'Send a chat message'
        }
    ]
}